import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    id: String,
    textColor: String,
    background: String,
    items: Array,
    textNotImages: Boolean,
    config: Object
  },
})

export default class Parallex2 extends CVueInstance {
  get getId() {
    return `${this.GetMyId()}-parallex2`;
  }
  public mounted() {
    let thisConfig = (this as any).config || {};
    this.tools.fullscreen();
    (window as any).$(`#${this.getId}`).slick({
      speed: thisConfig.speed || 500,
      infinite: thisConfig.infinite || true,
      arrows: thisConfig.arrows || false,
      slidesToShow: thisConfig.slidesToShow || 4,
      slidesToScroll: thisConfig.slidesToScroll || 1,
      autoplay: thisConfig.autoplay || true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    (window as any).$(`#${this.getId}`).parallax('50%', 0.5);
  }
}
